<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('customerProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('customerProfile.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">{{
              $t('add_new')
            }}</ts-button>
            <ts-button
              :waiting="waiting"
              outline
              @click.prevent="approveCustomer"
            >
              {{ $t('customerProfile.approved') }}
            </ts-button>
            <b-dropdown dropdown variant="outline-success">
              <template slot="button-content">
                <i
                  class="fas fa-circle-notch spin inline-block mr-1"
                  v-if="exporting"
                ></i>
                <i class="fas fa-file-excel"></i>
                {{ $t('customerProfile.exportExcel') }}
              </template>
              <b-dropdown-item
                :disabled="!checkedItems.length > 0"
                href="#"
                @click.prevent="exportExcel"
              >
                <i class="fas fa-check-square"></i>
                {{ $t('customerProfile.selectedCustomer') }}
              </b-dropdown-item>
              <b-dropdown-item href="#" @click.prevent="exportExcelAllCustomer">
                <i class="fas fa-users"></i>
                {{ $t('customerProfile.allCustomer') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="d-flex ts-space-x-3">
            <a-radio-group v-model="approveStatus" @change="fetchData()">
              <a-radio-button :value="undefined">
                {{ $t('all') }}
              </a-radio-button>
              <a-radio-button :value="0">
                {{ $t('customerProfile.pending') }}
                <span class="badge badge-danger">{{ pendingCount }}</span>
              </a-radio-button>
              <a-radio-button :value="2">
                {{ $t('customerProfile.approved') }}
              </a-radio-button>
            </a-radio-group>
            <ts-input
              v-model="search"
              v-tooltip="$t('customerProfile.search')"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row ts-mb-3">
                <div class="col-md-12">
                  <label class="">{{ $t('customerProfile.branchName') }}</label>
                  <a-select
                    style="width: 257px"
                    v-model="branch_id"
                    :options="branchs"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                    @change="changeBranch()"
                  >
                  </a-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{
                    $t('customerProfile.warehourseName')
                  }}</label>
                  <a-select
                    style="width: 257px"
                    v-model="location_id"
                    :options="locations"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                  </a-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="ts-mt-2">{{
                    $t('customerProfile.sale')
                  }}</label>
                  <a-select
                    style="width: 257px"
                    v-model="sale_id"
                    :options="sales"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                  </a-select>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <Table
          :columns="columns"
          :data="resources"
          :loading="loading"
          :showCheckbox="true"
          highlight-row
          stripe
          @on-select="onSelectCheck"
          @on-select-cancel="onSelectUncheck"
          @on-select-all="onSelectAllCheck"
          @on-select-all-cancel="onSelectAllUncheck"
          ref="tableCustomer"
        >
          <template slot-scope="{ row }" slot="branchName">
            {{ row.branch.branch_name_en }}
          </template>
          <template slot-scope="{ row }" slot="customerType">
            {{ row.type.customer_type }}
          </template>
          <template slot-scope="{ row }" slot="saleName">
            {{ row.sale ? row.sale.name : '' }}
          </template>
          <template slot-scope="{ row }" slot="generalCustomer">
            <span class="badge badge-success" v-if="row.is_general_customer"
              >Yes</span
            >
            <span class="badge badge-danger" v-else>No</span>
          </template>
          <template slot-scope="{ row }" slot="membership">
            <span class="badge badge-success" v-if="row.is_membership"
              >Yes</span
            >
            <span class="badge badge-danger" v-else>No</span>
          </template>
          <template slot-scope="{ row }" slot="approveStatus">
            <span class="badge badge-danger" v-if="row.approve_status == 0"
              >Pending</span
            >
            <span class="badge badge-success" v-if="row.approve_status == 1"
              >Partially Approved</span
            >
            <span class="badge badge-success" v-if="row.approve_status == 2"
              >Approved</span
            >
            <span class="badge badge-info" v-if="row.approve_status == 3"
              >Rejected</span
            >
          </template>
          <template slot-scope="{ row }" slot="userName">
            {{ row.user ? row.user.name : '' }}
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary mr-2"
              @click.prevent="edit(row)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(row)"
            >
              <a href="#" :disabled="row._deleting">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </template>
        </Table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('customerProfile.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="60%"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
import FromAction from './form1.vue'

export default {
  name: 'customerProfileIndex',
  components: {
    FromAction
  },
  data() {
    return {
      waiting: false,
      loading: false,
      exporting: false,
      errors: new Errors(),
      showForm: false,
      branchs: [],
      locations: [],
      checkedItems: [],
      sales: []
    }
  },
  computed: {
    ...mapState('customer/profile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.customer.profile.search
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_SEARCH', newValue)
        this.$store.commit('customer/profile/RESET_CURRENT_PAGE')
      }
    },
    approveStatus: {
      get() {
        return this.$store.state.customer.profile.approve_status
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_APPROVED_STATUS', newValue)
      }
    },
    location_id: {
      get() {
        return this.$store.state.customer.profile.location_id
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_LOCATION_ID', newValue)
      }
    },
    branch_id: {
      get() {
        return this.$store.state.customer.profile.branch_id
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_BRANCH_ID', newValue)
      }
    },
    sale_id: {
      get() {
        return this.$store.state.customer.profile.sale_id
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_SALE_ID', newValue)
      }
    },
    pendingCount() {
      return this.resources.filter(r => r.approve_status == 0).length
    },
    columns() {
      return [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: this.$t('customerProfile.branchName'),
          slot: 'branchName',
          width: 175
        },
        {
          title: this.$t('customerProfile.customerCode'),
          key: 'customer_code',
          width: 120
        },
        {
          title: this.$t('customerProfile.customerName'),
          key: 'customer_name',
          minWidth: 350
        },
        {
          title: this.$t('customerProfile.gender'),
          key: 'gender',
          minWidth: 150
        },
        {
          title: this.$t('customerProfile.phoneNumber'),
          key: 'contact_number',
          minWidth: 210
        },
        {
          title: this.$t('customerProfile.idCard'),
          key: 'ss_id_card',
          minWidth: 170
        },
        {
          title: this.$t('customerProfile.email'),
          key: 'contact_email',
          minWidth: 240
        },
        {
          title: this.$t('customerProfile.customerType'),
          slot: 'customerType',
          minWidth: 200
        },
        {
          title: this.$t('customerProfile.sale'),
          slot: 'saleName',
          minWidth: 180
        },
        {
          title: this.$t('customerProfile.salePosition'),
          key: 'sale_position',
          align: 'center',
          minWidth: 180
        },
        {
          title: this.$t('customerProfile.dealerType'),
          key: 'dealer_type',
          minWidth: 160
        },
        {
          title: this.$t('customerProfile.grade'),
          key: 'dealer_grade',
          align: 'center',
          minWidth: 100
        },
        {
          title: this.$t('customerProfile.isGeneralCustomer'),
          slot: 'generalCustomer',
          minWidth: 110,
          align: 'center'
        },
        {
          title: this.$t('customerProfile.isMembership'),
          slot: 'membership',
          minWidth: 170,
          align: 'center'
        },
        {
          title: this.$t('customerProfile.status'),
          slot: 'approveStatus',
          minWidth: 110,
          align: 'center'
        },
        {
          title: this.$t('customerProfile.discountRate'),
          minWidth: 170,
          key: 'membership_discount_rate',
          align: 'right'
        },
        {
          title: this.$t('customerProfile.createdBy'),
          slot: 'userName',
          align: 'center',
          minWidth: 170
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 120
        }
      ]
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.user.default_branch.branch_id]
    this.getBranch()
    this.getSaleList()
    this.changeBranch()
    this.location_id = [
      this.$store.state.authUser.user.default_location.location_id
    ]
  },
  methods: {
    ...mapActions('report/resource', ['getLocation', 'getFormViewModel']),
    ...mapActions('customer/profile', ['getFormViewModel']),
    getSaleList() {
      this.getFormViewModel({
        fnName: 'sale'
      }).then(response => {
        this.sales = response.data.sale
      })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('customer/profile/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('customer/profile/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('customer/profile/SET_EDIT_DATA', {})
      this.showForm = false
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('customer/profile/destroy', record.customer_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    getBranch() {
      this.loading = true
      this.$store
        .dispatch('security/user/getBranchAssignedForFilter')
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async changeBranch() {
      this.loading = true
      this.location_id = []
      await this.$store
        .dispatch('security/user/getWarehouseAssignedForFilter', {
          branch_id: this.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSelectCheck(selection, row) {
      if (!this.checkedItems.includes(row.customer_id)) {
        this.checkedItems.push(row.customer_id)
      }
    },
    onSelectUncheck(selection, row) {
      this.checkedItems = this.checkedItems.filter(
        key => key !== row.customer_id
      )
    },
    onSelectAllCheck(record) {
      this.setStudentListSelected(record)
    },
    setStudentListSelected(records) {
      this.checkedItems = []
      if (records.length > 0) {
        records.map(row => {
          this.checkedItems.push(row.customer_id)
        })
      }
    },
    onSelectAllUncheck(record) {
      this.checkedItems = []
    },
    exportExcelAllCustomer() {
      this.checkedItems = []
      this.exportExcel()
    },
    exportExcel() {
      this.errors = new Errors()
      this.exporting = true
      this.$store
        .dispatch('customer/profile/customerExportExcel', {
          customer_id: this.checkedItems
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.notice({ type: 'error', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    approveCustomer() {
      if (!this.checkedItems.length) {
        this.$toasted.error('Please select any dealers.')
        return
      }
      this.waiting = true
      this.$store
        .dispatch('customer/profile/approveMulti', {
          customer_id: this.checkedItems
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$refs.tableCustomer.checkedItems = []
          this.checkedItems = []
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'PROFILE',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500),
    location_id: debounce(function() {
      this.fetchData(this.search)
    }, 500),
    sale_id: debounce(function() {
      this.fetchData(this.search)
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('customer/profile/RESET_STATE')
    this.$store.commit('customer/profile/CLEAR_STATE')
    next()
  }
}
</script>
